export function validBulkCapacity(value, maximum) {
  return Number.isInteger(value) && Number.isInteger(maximum) && value >= 1 && value <= maximum;
}
export function canApplyBulkCapacity(status, value) {
  return !!status && status.can_apply === true && status.complete === true &&
    status.supported === true && status.idle === true && validBulkCapacity(value, status.maximum);
}
